import { Component, Input, OnInit } from "@angular/core";
import { HouseStatusService } from "@root/router/deprecated_and_do_not_use-house/house-status/house-status.service";
import { HttpCalendarService } from "@root/component/multi-calendar/http-calendar.service";
import { StoreService } from "@root/shared/service/store.service";
import { distinctUntilChanged, share, takeUntil, tap } from "rxjs";
import _ from "lodash";
import * as moment from "moment";
import { Moment } from "moment";
import { Subject } from "rxjs";
import { PlatformType } from "@root/config";
import {
  Child,
  Parent,
  MultiHouseCalendarService,
  SelectedData,
  TabName,
} from "../calendar/multi-house-calendar/multi-house-calendar.service";

@Component({
  selector: "host-operate-sidebar",
  templateUrl: "./operate-sidebar.component.html",
  styleUrls: ["./operate-sidebar.component.scss"],
})
export class OperateSidebarComponent implements OnInit {
  @Input() type: "hostex" | "channel" | "hour-reservation" = "hostex";
  // @Input() @InputBoolean() disablePast = false;
  hourRoomOrder = false;
  index = 0;
  /**
   * 当前实体
   * 如果选择的是房间，entity代表的是房间数据，类型为Child
   * 如果选择的是房型，entity代表的是房型数据，类型为Parent
   * Child可以通过c_parent属性反向寻找到自己的Parent相关的信息
   */
  entity: Child | Parent;
  entityType: "house" | "type";
  // house; // 房态日历专用
  // relatedHouse: EntityData; // 房价日历专用
  dateRange: Array<string> = [];
  /** @deprecated */
  listOfCalendar: { available: number; note: string }[] = [];
  listOfPriceCalendar = []; // 房价日历专用
  listOfRulesSettingHouse = []; // rules
  listOfForbiddenDates = [];
  listOfHostexPriceHouses: { type: string; id: number; title: string }[] = []; // 房态改价专用
  listOfHostexPricePrices = []; // 房态改价专用
  // houseCleanStatus = {};
  get nights() {
    const head = moment(_.head(this.dateRange));
    const last = moment(_.last(this.dateRange));
    return last.diff(head, "days") + 1;
  }

  get allowModifyAvailable() {
    const head = moment(_.head(this.dateRange));
    return head.isSameOrAfter(moment().subtract(1, "d"), "d");
  }

  // private dateChange$ = this.houseCalendarService.selectRaw$.pipe(
  //   distinctUntilChanged(),
  //   tap((value) => {
  //     this.updateDateRange(value);
  //   }),
  //   share(),
  // );

  private tabChange$ = this.houseCalendarService.sidebarTabRaw$.pipe(
    distinctUntilChanged(),
    tap((value) => this.updateTabIndex(value.type)),
  );

  private destroy$ = new Subject();

  constructor(
    private houseCalendarService: MultiHouseCalendarService,
    private httpService: HouseStatusService,
    private httpCalendarService: HttpCalendarService,
    private storeService: StoreService,
  ) {}

  ngOnInit() {
    console.log("type: ", this.type);
    return;
    // console.log("============init!!!!!!!!!!!!!!");
    // if (this.type !== "hour-reservation") {
    //   this.dateChange$.pipe(takeUntil(this.destroy$)).subscribe();
    //   this.tabChange$.pipe(takeUntil(this.destroy$)).subscribe();

    //   const selectedData = this.houseCalendarService.selectedData;

    //   this.updateEntityData(selectedData);
    //   this.updateDateRange(selectedData);
    //   // this.updateTabIndex();
    //   console.log("selectData: ", selectedData, "this.type: ", this.type);
    //   if (this.type === "hostex") {
    //     // this.updateHouse(selectedData);

    //     if (selectedData.data.type === "type") {
    //     } else {
    //       this.fetchForbiddenDateList();
    //       // this.fetchStatusCalendarList();
    //       // this.fetchCurrencyList();
    //       // this.fetchCustomConfigList();
    //       this.fetchHouseAndTypeInfo();
    //       // this.fetchHouseCleanStatus();
    //     }
    //   } else {
    //     this.updateTabIndex();
    //     // this.updateRelatedHouse(selectedData);
    //     this.fetchPriceStatusCalendarList();
    //   }
    // }

    console.log("this.eneity: ", this.entity);
  }

  // updateEntityData(data: SelectedData) {
  //   this.entity = data.data.payload;
  //   this.entityType = data.data.type;
  //   console.log('entity: ', this.entity, 'entityType: ', this.entityType);
  // }

  // updateDateRange(value: SelectedData) {
  //   const dates = value.dates;
  //   const head: Moment = _.get(dates, 'head') || moment();
  //   const last: Moment = _.get(dates, 'last') || moment();

  //   this.dateRange = [head.format('YYYY-MM-DD'), last.format('YYYY-MM-DD')];
  // }

  // updateHouse(value: SelectedData) {
  //   this.house = _.get(value, 'data');
  //   console.log('this.house: ', this.house);
  // }

  // updateRelatedHouse(value: SelectedData) {
  //   // this.relatedHouse = _.get(value.dates, 'relatedHouse');
  //   this.relatedHouse = _.get(value, 'data');
  //   console.log('relatedHouse: ', this.relatedHouse);
  // }

  updateTabIndex(name?: TabName) {
    console.log("updateTabIndex: ", name);

    if (name === "hour-room-order") {
      this.hourRoomOrder = true;
      return;
    }

    const map: Record<TabName, number> = {
      "manual-order": 0,
      "hostex-status": 1,
      "hostex-price": 2,
      "channel-price": 0,
      "rules-setting": 1,
      "channel-status": this.listOfRulesSettingHouse.length ? 2 : 1,
      "hour-room-order": 0,
    };

    const key = "operate-sidebar-tab-name";
    const value = this.storeService.get(key, 2) || 0;

    if (name !== undefined) {
      this.storeService.set(key, name, 2);
      this.index = map[name];
    } else {
      this.index = map[value];
    }
  }

  // updateTotalPrice(list: Array<any>) {
  //   this.price = _.reduce(list, (sum, n) => sum + _.head(n.prices).price, 0);
  // }

  /**
   * 房态页获取房间 id 关联的房间/房型，并进一步获取关联房间/ 房型的第三方房源的价格列表
   */
  fetchHouseAndTypeInfo() {
    console.log("fetchHouseAndTypeInfo:", this.entity);
    // const house_id = this.house.id;
    const house_id = (this.entity as Child).c_id;
    this.httpCalendarService.getHouseAndTypeInfo({ house_id }).subscribe((res) => {
      const house = res?.data?.house as { id: number; house_title: string };
      const houseType = res?.data?.house_type as { id: number; title: string };

      const result = [];
      const house_ids: number[] = [];
      const house_type_ids: number[] = [];

      if (house) {
        const houseInfo = {
          type: "house",
          id: house.id,
          title: house.house_title,
        };
        result.push(houseInfo);
        house_ids.push(house.id);
      }

      if (houseType) {
        const houseTypeInfo = { type: "type", ...houseType };
        result.push(houseTypeInfo);
        house_type_ids.push(houseType.id);
      }

      this.listOfHostexPriceHouses = result;

      console.log("list of hostex price houses: ", this.listOfHostexPriceHouses);
      // this.listOfHostexPricePrices = data.house_prices;
      this.fetchPriceList(house_ids, house_type_ids);
      this.updateTabIndex();
    });
  }

  /**
   *  房态改价获取价格接口
   *  房态改价页需要 listOfHostexPricePrices
   *  获取该数据之后，过滤出符合条件的数据，就是 listOfRulesSettingHouse，房态预定规则需要
   */
  fetchPriceList(house_ids = [], house_type_ids = []) {
    if (_.isEmpty(house_ids) && _.isEmpty(house_type_ids)) {
      this.listOfHostexPricePrices = [];
      return;
    }

    const begin = moment(_.head(this.dateRange)).format("YYYY-MM-DD");
    const end = moment(_.last(this.dateRange)).format("YYYY-MM-DD");

    const params = { begin, end, type: "house_status", version: "4.0.2" };
    if (!_.isEmpty(house_ids)) {
      _.assign(params, { house_ids });
    }

    if (!_.isEmpty(house_type_ids)) {
      _.assign(params, { house_type_ids });
    }
    this.httpCalendarService.getPriceList(params).subscribe((res) => {
      this.listOfHostexPricePrices = res?.data?.list || [];

      console.log("list of hostex price: ", this.listOfHostexPricePrices);
      this.listOfRulesSettingHouse = this.listOfHostexPricePrices?.filter((item) =>
        [PlatformType.Booking, PlatformType.Agoda, PlatformType.Airbnb].includes(item.thirdparty_type),
      );
    });
  }

  /**
   * @deprecated
   * 房态页获取所选日期的房态信息
   */
  fetchStatusCalendarList() {
    // const house_id = this.house.id;
    const house_id = (this.entity as Child).c_id;
    const begin = moment(_.head(this.dateRange)).format("YYYY-MM-DD");
    const end = moment(_.last(this.dateRange)).format("YYYY-MM-DD");
    this.httpCalendarService
      .getCalendarListV2({
        begin,
        end,
        house_ids: JSON.stringify([house_id]),
        version: "2.4",
      })
      .subscribe((res) => {
        const calendar = _.get(res.data, "calendar_list[0].calendar") || [];
        this.listOfCalendar = calendar;
        console.log(
          "🚀 ~ file: operate-sidebar.component.ts:260 ~ OperateSidebarComponent ~ .subscribe ~ this.listOfCalendar:",
          this.listOfCalendar,
        );
      });
  }

  /**
   *  渠道侧边栏获取价格接口
   *  改价、渠道库存/房态  页需要 listOfPriceCalendar
   *  获取到该数据之后，过滤出符合条件的数据，就是 listOfRulesSettingHouse，房价预定规则需要
   */
  fetchPriceStatusCalendarList() {
    const unique_keys = (this.entity as Child)?.c_parent?.p_children_ids;

    const params = {
      // unique_keys: JSON.stringify(relatedIds),
      unique_keys: JSON.stringify(unique_keys),
      begin: moment(_.head(this.dateRange)).format("YYYY-MM-DD"),
      end: moment(_.last(this.dateRange)).format("YYYY-MM-DD"),
      version: "2.4",
    };
    this.httpCalendarService.getCalendarListV2(params).subscribe((res) => {
      const list = _.get(res, "data.list");
      this.listOfPriceCalendar = list.map((item) => ({
        ...item,
        house_info: (this.entity as Child)?.c_parent.p_children.find((key) => key.c_id === item.unique_key),
      }));

      this.listOfRulesSettingHouse = this.listOfPriceCalendar
        .filter((item) =>
          [PlatformType.Booking, PlatformType.Agoda, PlatformType.Airbnb].includes(item.thirdparty_type),
        )
        .map((item) => ({ ...item, thirdparty_house_title: item.house_info?.thirdparty_house_title }));
      console.log("listOfPriceCalendar: ", this.listOfPriceCalendar);
    });
  }

  fetchForbiddenDateList() {
    // const house_id = this.house.id;
    const house_id = (this.entity as Child).c_id;
    this.httpService.getForbiddenDateList({ house_id }).subscribe((res) => {
      this.listOfForbiddenDates = res.data;
      console.log("[operate sidebar forbidden dates]: ", this.listOfForbiddenDates);
    });
  }

  onClickCancel() {
    this.houseCalendarService.cancelSelect();
  }
}
